import { IBlock } from "../../../framework/src/IBlock"
import { Message } from "../../../framework/src/Message"
import { BlockComponent } from "../../../framework/src/BlockComponent"
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum"
import { runEngine } from "../../../framework/src/RunEngine"

// Customizable Area Start
import React from "react"
import { CometChat } from "@cometchat/chat-sdk-javascript"
import { userProfile } from "./assets"
import { Linking } from "react-native"
import {
  getStorageData,
  removeStorageData,
  setStorageData,
} from "framework/src/Utilities"
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded"
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined"
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined"
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded"
import { getTotalUnreadCount } from "../../../components/src/cometchatService"
import { CustomContext } from "../../../components/src/CustomContext.web"
import { clearUserIdFromAnalytics, logEvent } from "../../../components/src/utils/googleAnalytics/analyticsAdapter.web";
import { navigateToUserProfile } from "../../../components/src/utils/userSlug.web"

const UNREAD_LISTENER_ID = "UNREAD_LISTENER_ID"

export interface CommonPopoverProps {
  open: boolean
  menus: IMenu[]
  anchorEl: HTMLElement | null
  onClose: () => void
}

interface IMenu {
  icon: React.ReactNode
  title: string
  handleClick: () => void
}

interface IProfile {
  id: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  profileImg: string
  lastFetched: number
}

interface Account {
  id: number
  first_name: string
  last_name: string
  email: string
  roles: string
}

interface NotificationAttributes {
  id: number
  headings: string
  contents: string
  is_read: boolean
  chat_notification: boolean
  read_at: string
  created_at: string
  user_image_url: string
  account: Account
}

interface NotificationItem {
  id: string
  type: string
  attributes: NotificationAttributes
}

interface NotificationMeta {
  message: string
  notification_count: number
}

interface NotificationResponse {
  data: NotificationItem[]
  meta: NotificationMeta
}
interface IUserProfileSuccessResponse {
  data: {
    id: string
    type: string
    attributes: {
      activated: boolean
      country_code: number
      email: string
      first_name: string
      full_phone_number: string
      last_name: string
      height: string | null
      weight: string | null
      roles: string
      blocked: boolean
      type: string | null
      status: string
      role_id: number | null
      gender: string | null
      full_name: string
      age: string | null
      date_of_birth: string | null
      locations: string | null
      languages: string[]
      description: string | null
      created_at: string
      updated_at: string
      unique_auth_id: string
      social_media_links: Object
      categories: []
      user_careers: []
      user_educations: []
      user_links: Object
      user_image_url: string
      cover_photo: string
    }
  }
}

interface IUserProfileErrorResponse {
  errors: {
    token: string
  }
}
// Customizable Area End

export const configJSON = require("./config")

export interface Props {
  navigation: any
  id: string
  // Customizable Area Start
  drawerContent?: boolean
  profilePicture?: string | null
  isAuthenticated?: boolean
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  webDrawer: boolean
  token: any
  drawerItems: any
  menuOpen: boolean
  isLoading: boolean
  menuAnchorEl: HTMLDivElement | null
  anchorEl: HTMLElement | null
  isAuthenticated: boolean
  isLogoutDialog: boolean
  userProfile: IProfile | null
  notificationCount: number
  notifications: NotificationItem[]
  // Customizable Area End
}

interface SS {
  id: any
  // Customizable Area Start
  // Customizable Area End
}

export default class NavigationMenuController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  apiGetDataCallId: string = ""
  getUserDetailsApiCallId: string = ""
  getNotificationApiCallId: string = ""
  MENUS: IMenu[] = []
  EXPIRATION_TIME = 60 * 60 * 1000
  static contextType = CustomContext
  // Customizable Area End

  constructor(props: Props) {
    super(props)
    this.receive = this.receive.bind(this)

    // Customizable Area Start
    this.handleGetNotification = this.handleGetNotification.bind(this)
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      // Customizable Area End
    ]

    this.state = {
      // Customizable Area Start
      webDrawer: false,
      token: "",
      drawerItems: [],
      menuOpen: false,
      isLoading: false,
      menuAnchorEl: null,
      anchorEl: null,
      isAuthenticated: false,
      isLogoutDialog: false,
      userProfile: null,
      notificationCount: 0,
      notifications: [],
      // Customizable Area End
    }
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages)

    // Customizable Area Start
    this.MENUS = [
      {
        title: "My Profile",
        icon: <PersonOutlineRoundedIcon />,
        handleClick: this.handleMyProfileRedirection,
      },
      {
        title: "My Plans",
        icon: <ShoppingCartOutlinedIcon />,
        handleClick: this.handleMyOrdersRedirection,
      },
      {
        title: "Settings",
        icon: <SettingsOutlinedIcon />,
        handleClick: this.handleSettingsRedirection,
      },
      {
        title: "Logout",
        icon: <LogoutRoundedIcon />,
        handleClick: this.openLogoutDialog,
      },
    ]
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message)
    // Customizable Area Start
    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    )

    const response = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    )

    if (getName(MessageEnum.SessionResponseMessage) === message.id) {
      let token = message.getData(getName(MessageEnum.SessionResponseToken))
      runEngine.debugLog("TOKEN", token)
      this.setState({ token: token }, () => {
        this.getMenuItems()
      })
    } else if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      this.apiGetDataCallId !== "" &&
      this.apiGetDataCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      var responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      )
      if (responseJson) {
        this.setState({ drawerItems: responseJson })
      }
    } else if (apiRequestCallId === this.getNotificationApiCallId) {
      this.handleGetNotification(response)
    }

    if (apiRequestCallId === this.getUserDetailsApiCallId) {
      this.handleGetUserProfileResponse(response)
    }
    // Customizable Area End
  }

  // Customizable Area Start
  get customContext(): React.ContextType<typeof CustomContext> {
    return this.context as React.ContextType<typeof CustomContext>
  }

  async componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<S>
  ): Promise<void> {
    const { profilePicture } = this.props
    const { isAuthenticated, userProfile } = this.state

    if (prevState.isAuthenticated !== isAuthenticated) {
      if (isAuthenticated) {
        this.addCometchatListeners()
        this.handleGetUnreadMessagesCount()
      } else {
        this.customContext.setUnreadCount(0)
        this.removeCometchatListeners()
      }
    }

    if(prevProps.profilePicture !== profilePicture && userProfile) {
      this.setState((prevState: S) => ({
        userProfile: prevState.userProfile
          ? { ...prevState.userProfile, profileImg: profilePicture || "" }
          : null
      }))
    }
  }

  openLogoutDialog = () => {
    this.setState({ isLogoutDialog: true })
  }

  closeLogoutDialog = () => {
    this.setState({ isLogoutDialog: false })
  }

  handleMyProfileRedirection = () => {
    logEvent("nav_menu_click", { menu_item: "My Profile" });
    const profileDataString = localStorage.getItem(configJSON.PROFILE_KEY);
    const profileData = profileDataString ? JSON.parse(profileDataString) : null;
    if(profileData) {
      const {
        id,
        firstName,
        lastName
      } = profileData;

      this.handleCloseMenu()
      navigateToUserProfile(this.props.navigation, {
        id,
        firstName,
        lastName
      });
    }
  }

  handleMyOrdersRedirection = () => {
    logEvent("nav_menu_click", { menu_item: "My Plans" });
    this.handlePageRedirection("MyPlans")
  }

  handleSettingsRedirection = () => {
    logEvent("nav_menu_click", { menu_item: "Settings" });
    this.handlePageRedirection("Settings2")
  }

  handleGetUserProfileResponse = async (
    responseJson: IUserProfileSuccessResponse | IUserProfileErrorResponse
  ) => {
    if ("data" in responseJson) {
      const {
        data: {
          id,
          attributes: {
            first_name,
            last_name,
            email,
            full_phone_number,
            user_image_url,
          },
        },
      } = responseJson
      const userProfile: IProfile = {
        id,
        firstName: first_name,
        lastName: last_name,
        email,
        phoneNumber: full_phone_number,
        profileImg: user_image_url,
        lastFetched: Date.now(),
      }
      await setStorageData(configJSON.PROFILE_KEY, JSON.stringify(userProfile))
      this.setState({ userProfile })
    }
  }

  handleLogout = async () => {
    try {
      this.setState({ isLoading: true })
      logEvent("nav_menu_click", { menu_item: "Logout" });
      clearUserIdFromAnalytics()
      const isUser = await CometChat.getLoggedinUser()
      if (isUser) {
        await CometChat.logout()
      }
      await removeStorageData(configJSON.PROFILE_KEY)
      await removeStorageData(configJSON.REFRESH_TOKEN)
      await removeStorageData(configJSON.COMET_AUTH_TOKEN_KEY)
      await removeStorageData(configJSON.TOKEN)
      this.customContext.setIsLoggedIn(false)
      this.setState({
        isLoading: false,
        isLogoutDialog: false,
        isAuthenticated: false,
        menuAnchorEl: null,
      })
      this.handlePageRedirection("Home")
    } catch (err) {}
  }

  toggleDrawer = (event: any) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }
    this.setState({ webDrawer: !this.state.webDrawer })
  }

  handlePageRedirection = (route: string) => {
    logEvent("nav_menu_click", { menu_item: route });
    const navigation = new Message(getName(MessageEnum.NavigationMessage))
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), route)
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props)
    this.send(navigation)
  }

  handleChatPageRedirection = () => {
    logEvent("nav_menu_click", { menu_item: "Chat" });
    this.handlePageRedirection("Chat")
  }

  handleNavigation = (path: string) => {
    logEvent("nav_menu_click", { menu_item: path });
    this.props.navigation.navigate(path)
  }

  handleOpenMenu = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    this.setState({
      menuOpen: true,
      menuAnchorEl: event.currentTarget,
    })
  }

  handleCloseMenu = () => {
    this.setState({
      menuOpen: false,
      menuAnchorEl: null,
    })
  }
  onPressMenuItem = (menuItem: any) => {
    let path = menuItem.url

    var tarea_regex = /^(http|https)/
    if (tarea_regex.test(String(path).toLowerCase())) {
      if (this.isPlatformWeb()) {
        window.open(path)
      } else {
        Linking.openURL(path)
      }
    } else {
      const msg: Message = new Message(getName(MessageEnum.NavigationMessage))
      msg.addData(getName(MessageEnum.NavigationTargetMessage), path)
      msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props)
      this.send(msg)
    }
  }

  userProfileProps = {
    source: userProfile,
  }

  checkIsAuthenticated = async () => {
    const token = await getStorageData(configJSON.TOKEN)
    if (!!token) {
      this.setState({ isAuthenticated: true })
      const profile = await getStorageData(configJSON.PROFILE_KEY, true)
      this.getUnreadNotificationList()
      this.handleGetUnreadMessagesCount()
      if (profile && Date.now() - profile.lastFetched < this.EXPIRATION_TIME) {
        this.setState({ userProfile: profile })
        return
      }
      this.getUserProfileApi()
    }
  }

  addCometchatListeners = () => {
    CometChat.addMessageListener(
      UNREAD_LISTENER_ID,
      new CometChat.MessageListener({
        onTextMessageReceived: this.handleGetUnreadMessagesCount,
        onMediaMessageReceived: this.handleGetUnreadMessagesCount,
        onMessagesRead: this.handleGetUnreadMessagesCount,
      })
    )
  }

  removeCometchatListeners = () => {
    CometChat.removeMessageListener(UNREAD_LISTENER_ID)
  }

  handleGetUnreadMessagesCount = async () => {
    const totalCount = await getTotalUnreadCount(
      this.customContext.selectedChatUID
    )
    this.customContext.setUnreadCount(totalCount)
  }

  async componentDidMount() {
    super.componentDidMount()
    this.getToken()
    // Customizable Area Start
    if (this.isPlatformWeb() === false) {
      this.props.navigation.addListener("willFocus", () => {
        this.getToken()
      })
    }
    this.checkIsAuthenticated()
    // Customizable Area End
  }

  getToken = () => {
    const msg: Message = new Message(getName(MessageEnum.SessionRequestMessage))
    this.send(msg)
  }

  getMenuItems = async () => {
    let token = this.state.token

    const header = {
      "Content-Type": configJSON.jsonApiContentType,
      token: token,
    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    )

    this.apiGetDataCallId = requestMessage.messageId

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getMenuItemsEndPoint
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethodType
    )

    runEngine.sendMessage(requestMessage.id, requestMessage)
    return true
  }

  getUserProfileApi = async () => {
    const token = await getStorageData(configJSON.TOKEN)

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token,
    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    )

    this.getUserDetailsApiCallId = requestMessage.messageId

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.userProfileApiEndpoint
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethodType
    )

    runEngine.sendMessage(requestMessage.id, requestMessage)
    return true
  }

  handleNotificationPopupClose = () => {
    this.setState({ anchorEl: null })
  }

  handleBellIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    logEvent("nav_menu_click", { menu_item: "Notifications" });
    this.setState({
      anchorEl: event.currentTarget,
    })
  }

  getUnreadNotificationList = async () => {
    const token = await getStorageData(configJSON.TOKEN)
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    )
    this.getNotificationApiCallId = requestMessage.messageId
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getNotification
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": "application/json",
        token,
      })
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    )
    runEngine.sendMessage(requestMessage.id, requestMessage)
  }

  updateUnreadNotificationCount = (count: number) => {
    this.setState({ notificationCount: count })
  }

  handleGetNotification = (responseJson: NotificationResponse) => {
    const { meta, data } = responseJson || {}
    this.setState({
      notificationCount: meta?.notification_count ?? 0,
      notifications: data ?? [],
    })
  }
  // Customizable Area End
}
